import { DataForm, ResetForm } from './types'

export const INIT_FORM: DataForm = {
  externalPhoto: { dateTime: null, uri: null },
  gillPhoto: { dateTime: null, uri: null },
  internalPhoto: { dateTime: null, uri: null },
  centerId: null,
  cageName: null,
  centerName: null,
  cageId: null,
  date: null,
  time: null,
  additionalPhotos: {},
  comments: '',
  formId: null,
  stateForm: null,
}

export const RESET_FORM: ResetForm = {
  externalPhoto: { dateTime: null, uri: null },
  gillPhoto: { dateTime: null, uri: null },
  internalPhoto: { dateTime: null, uri: null },
  cageName: null,
  cageId: null,
  date: null,
  time: null,
  additionalPhotos: {},
  comments: '',
  formId: null,
  stateForm: null,
}
